export enum EUnit {
    PX = "px",
    REM = "rem",
    EM = "em",
    PERCENT = "%",
}
